/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterCreatedAt = new PostFilter([
  ['created_at', PostFilterComparison.gte],
  ['created_at', PostFilterComparison.lte],
]);
